import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getAccessToken } from './auth';

// An empty api service where we inject endpoints into
export const cognitoApi = createApi({
  reducerPath: 'cognitoApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND_URI,
    prepareHeaders: async (headers) => {
    // By default, if we have a token in the store, let's use that for authenticated requests
      const accessToken = await getAccessToken();
      await headers.set('Authorization', `Bearer ${String(accessToken)}`);
      return headers;
    },
  }),
  tagTypes: [
    'Users',
    'StudentSnapshots',
    'EnrolmentSnapshots',
    'Tutorials',
    'Students',
    'Staff',
    'Videos',
    'VideoCategories',
    'VideoPermissions',
    'Leads',
    'Permissions',
    'PermissionGroups',
    'Notes',
    'ExamMarkingRequests',
    'NotesCategories',
    'NotesPermissions',
    'Exams',
    'ExamTypes',
    'ExamQuestions',
    'ExamAttempts',
    'ExamAttemptsByMarker',
    'Classes',
    'ClassNotes',
    'UserNotes',
    'LessonEnrolments',
    'Topics',
    'TopicGroups',
    'StudentAnalytics',
    'Courses',
    'Streams',
    'Lessons',
    'LessonTemplates',
  ],
  endpoints: () => ({}),
});
